import { Location } from "@reach/router";
import React, { useEffect } from "react";
import ReactGA from "react-ga";
//
export default ({ children }) => {
	useEffect(() => {
		ReactGA.initialize("UA-141533087-1");
	}, []);

	if (typeof document === "undefined") {
		return children;
	}

	return (
		<Location>
			{({ location }) => {
				ReactGA.pageview(location.pathname + location.search + location.hash);
				return children;
			}}
		</Location>
	);
};
